import { useCustomSWR } from 'utils/hooks/fetchers'

export const useVenderByUrlId = (urlId = null, swrOptions) => {
  return useCustomSWR(urlId && `/venders/urlId/${urlId}`, swrOptions)
}
